'use client';
import cn from 'classnames';
import NextLink from 'next/link';
import Image from 'next/image';
import { BuilderImageProps } from '@/types/Builder';

import './StaticHeroV2.style.scss';
import { useUser } from '@/components/hook/user';

type StaticHeroProps = {
  priority?: boolean;
  loggedOut: {
    image: {
      desktop: BuilderImageProps;
      mobile: BuilderImageProps;
    };
    linkUrl?: string;
  };
  loggedIn?: {
    image?: {
      desktop: BuilderImageProps;
      mobile: BuilderImageProps;
    };
    linkUrl?: string;
  };
};

function StaticHeroV2(props: StaticHeroProps) {
  const {
    loggedOut: loggedOutProps,
    loggedIn: loggedInProps,
    priority = false
  } = props;
  const { value: user } = useUser();

  const propsToUse = {
    priority,
    image:
      user && loggedInProps?.image ? loggedInProps.image : loggedOutProps.image,
    linkUrl:
      user && loggedInProps?.linkUrl
        ? loggedInProps.linkUrl
        : loggedOutProps.linkUrl
  };

  const imageContent = (
    <>
      <div
        className='StaticHeroV2-container StaticHeroV2-container-mobile'
        style={{
          paddingBottom: `${
            (propsToUse.image.mobile.imageHeight /
              propsToUse.image.mobile.imageWidth) *
            100
          }%`
        }}
      >
        <Image
          className='StaticHeroV2-image StaticHeroV2-image-mobile'
          src={propsToUse.image.mobile.image}
          alt={propsToUse.image.mobile.imageAltText}
          height={propsToUse.image.mobile.imageHeight}
          width={propsToUse.image.mobile.imageWidth}
          priority={priority}
        />
      </div>
      <div
        className='StaticHeroV2-container StaticHeroV2-container-desktop'
        style={{
          paddingBottom: `${
            (propsToUse.image.desktop.imageHeight /
              propsToUse.image.desktop.imageWidth) *
            100
          }%`
        }}
      >
        <Image
          className='StaticHeroV2-image StaticHeroV2-image-desktop'
          src={propsToUse.image.desktop.image}
          alt={propsToUse.image.desktop.imageAltText}
          height={propsToUse.image.desktop.imageHeight}
          width={propsToUse.image.desktop.imageWidth}
          priority={priority}
        />
      </div>
    </>
  );

  return (
    <div className={cn('StaticHeroV2')}>
      {propsToUse.linkUrl ? (
        <NextLink href={propsToUse.linkUrl}>{imageContent}</NextLink>
      ) : (
        imageContent
      )}
    </div>
  );
}

export default StaticHeroV2;
